import React, { useEffect, useState } from "react";
import { Card, CardContent, Box, CircularProgress, Grid, Typography } from "@mui/material";
import axios from "axios";

const UserAgreement = () => {
    const token = localStorage.getItem("Token");
    const AgreementUrl = localStorage.getItem("AgreementUrl");
    const [userAgreement, setUserAgreement] = useState("");
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (AgreementUrl) {
            axios
                .get(`${process.env.REACT_APP_API_URL}/UserDocument/ViewPatientDocument?path=${AgreementUrl}`, {
                    headers: { Authorization: `Bearer ${token}` },
                })
                .then((response) => {
                    setUserAgreement(response); 
                })
                .catch((error) => {
                    console.error("Error fetching agreement:", error);
                    setError("Failed to load the agreement.");
                })
                .finally(() => {
                    setLoading(false);
                });
        }
    }, [AgreementUrl, token]);

    return (
        <div className="page-content">
        <Box  sx={{ display: "flex", justifyContent: "center", }}>
            <Card sx={{ maxWidth: "900px", width: "100%", p: 2, boxShadow: 3 }}>
                <CardContent>
                    {loading ? (
                        <Box display="flex" justifyContent="center" alignItems="center" height="500px">
                            <CircularProgress />
                        </Box>
                    ) : error ? (
                        <Typography color="error" textAlign="center">
                            {error}
                        </Typography>
                    ) : (
                        <Grid item xs={12} sx={{ display: "flex", justifyContent: "center" }}>
                            <iframe
                                title="User Agreement"
                                height="500px"
                                width="100%"
                                src={userAgreement}
                                style={{
                                    border: "none",
                                    borderRadius: "8px",
                                    boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
                                }}
                            ></iframe>
                        </Grid>
                    )}
                </CardContent>
            </Card>
        </Box>
        </div>
    );
};

export default UserAgreement;
